import { NgStyle } from '@angular/common';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IconType } from 'src/app/tinea-components/icon/enum/icon-type';
import { BaseTableMapper } from 'src/app/tinea-components/table/mapper/BaseTableMapper';
import { TableModel } from 'src/app/tinea-components/table/models/input/table-model';
import { TableRows } from 'src/app/tinea-components/table/models/input/table-rows';
import { TableTd } from 'src/app/tinea-components/table/models/input/table-td';
import { TableTh } from 'src/app/tinea-components/table/models/input/table-th';
import { ValueCell } from 'src/app/tinea-components/table/models/input/value-cell';
import { ConfiguredGraph, DataGroupedByAxis, Role } from 'src/swagger-gen/web-secured/models';

@Injectable({
    providedIn: 'root'
  })
export class StatsChartMapper extends BaseTableMapper {

    // -- configuration
    readonly CSS_CLASS_CONFIG = 'table-stats';

    readonly DISPLAY_NO_DATA = '--';

    //
    readonly COLUMN_ID_TAG = 'TAG';
    readonly COLUMN_ID_AXIS = 'AXIS';
    readonly COLUMN_ID_MIN = 'MIN';
    readonly COLUMN_ID_MAX = 'MAX';
    readonly COLUMN_ID_AVG = "AVERAGE"

    table: TableModel;

    constructor(private translate: TranslateService) {
        super();
        this.table = new TableModel();
    }

    init(configuredGraph: ConfiguredGraph, stats: Array<DataGroupedByAxis>): TableModel {
        this.table = new TableModel();
        // configuration
        this.initConfiguration();
        // header
        this.initHeader();
        // data
        this.initDataRow(configuredGraph,stats);

        return this.table;
    }

    initConfiguration(): void {
        this.table.configuration.cssClass = this.CSS_CLASS_CONFIG;
        this.table.configuration.noDataRowMsg = this.translate.instant('error.no_result');
    }

    initHeader(): void {

        const thTagName = this.createSimpleTh(this.COLUMN_ID_TAG, this.translate.instant('stations.configuredGraphs.stats.tagName'));
        const thAxis = this.createSimpleTh(this.COLUMN_ID_AXIS, this.translate.instant('stations.configuredGraphs.stats.axis'));
        const thMin = this.createSimpleTh(this.COLUMN_ID_MIN, this.translate.instant('stations.configuredGraphs.stats.min'));
        const thMax = this.createSimpleTh(this.COLUMN_ID_MAX, this.translate.instant('stations.configuredGraphs.stats.max'));
        const thMoy = this.createSimpleTh(this.COLUMN_ID_AVG, this.translate.instant('stations.configuredGraphs.stats.average'));

        let thList = [thTagName,thAxis,thMin,thMoy,thMax]
        
        this.setHeaderCells(thList);
    }

    initDataRow(configuredGraph: ConfiguredGraph,stats: Array<DataGroupedByAxis>): void {
        configuredGraph.configuration.tags.forEach(tag => {
            const tableRows = new TableRows(tag);
            //const tdTagName = this.createSimpleTd(this.COLUMN_ID_TAG, tag.name || this.DISPLAY_NO_DATA);
            const tdTagName = new TableTd();
            const tagNameCell = new ValueCell();
            tagNameCell.displayedValue = tag.name;
            const style = {
                'background-color': tag.color,
            };
            tagNameCell.addIcon('BEFORE', IconType.FONTAWESOME, null, 'fa fa-circle indicatorTagAxis', null, style);
            tdTagName.valueCells.push(tagNameCell);
            tableRows.cells.push(tdTagName);

            const axis = configuredGraph.configuration.configurationYAxis.find((elem) => (elem.index === tag.yAxis));
            const tdAxis = new TableTd();
            const axisCell = new ValueCell();
            axisCell.displayedValue = axis.name;
            const styleAxis = {
                'background-color': axis.color,
            };
            axisCell.addIcon('BEFORE', IconType.FONTAWESOME, null, 'fa fa-circle indicatorTagAxis', null, styleAxis);
            tdAxis.valueCells.push(axisCell);
            tableRows.cells.push(tdAxis);
            
            const stat = stats.find((elem) => (elem.tag === tag.name));
            var tdMin = this.createSimpleTd(this.COLUMN_ID_MIN, this.DISPLAY_NO_DATA);
            var tdMax = this.createSimpleTd(this.COLUMN_ID_MAX, this.DISPLAY_NO_DATA);
            var tdAvg = this.createSimpleTd(this.COLUMN_ID_AVG, this.DISPLAY_NO_DATA|| this.DISPLAY_NO_DATA);
            if(stat) {
                tdMin = this.createSimpleTd(this.COLUMN_ID_MIN, stat.stats ? parseFloat(stat.stats.minValue).toFixed(2) : this.DISPLAY_NO_DATA);
                tdMax = this.createSimpleTd(this.COLUMN_ID_MAX, stat.stats ? parseFloat(stat.stats.maxValue).toFixed(2) :  this.DISPLAY_NO_DATA);
                tdAvg = this.createSimpleTd(this.COLUMN_ID_AVG, stat.stats ? parseFloat(stat.stats.averageValue).toFixed(2) : this.DISPLAY_NO_DATA|| this.DISPLAY_NO_DATA);
            }
            // add cells
            // ================>
            tableRows.cells = [tdTagName, tdAxis, tdMin, tdAvg, tdMax];
            
            // push row
            // ================>
            this.table.dataRow.push(tableRows);

        });
    }

    getDisplayNetworks(role: Role) {
        let arrayName = [];
        let displayedValue = this.DISPLAY_NO_DATA;
        if(role.authorizations.length > 0) {
            role.authorizedNetworks.forEach((network) => {
                arrayName.push(network.name);
            })
            displayedValue = arrayName.toString();
        }

        return displayedValue;
    } 

    setHeaderCells(thList: TableTh[]): void {
        this.table.header.cells = thList;
    }
}
